import { CSSProperties, ReactNode } from "react";
import { ConfigProvider, Modal as AntdModal } from "antd";
import { usePalette } from "@/shared/theme";
import type { ModalProps as AntdModalProps } from "antd/es/modal/interface";
import { twMerge } from "tailwind-merge";
import Text from "@/shared/typography/text";

export type ModalProps = AntdModalProps & { footer?: ReactNode };

const paddings = "!py-4 !px-5 !xl:px-9 !xl:py-6";

export const Modal = (props: ModalProps) => {
  const { title, children, footer = null, classNames, ...args } = props;

  return (
    <Config>
      <AntdModal
        centered
        destroyOnClose
        style={
          {
            "--ant-modal-content-padding": "0",
            "--ant-modal-header-margin-bottom": "0",
          } as CSSProperties
        }
        title={<Title>{title}</Title>}
        footer={
          footer && (
            <div
              className={twMerge(paddings, "flex justify-end gap-6 lg:pb-8")}
              key={"buttons"}
            >
              {footer}
            </div>
          )
        }
        {...args}
        classNames={{
          ...classNames,
          body: twMerge(
            "rounded-t-lg",
            "max-h-[90vh] overflow-auto",
            paddings,
            classNames?.body,
          ),
        }}
      >
        {children}
      </AntdModal>
    </Config>
  );
};

function Config({ children }: { children: ReactNode }) {
  const palette = usePalette();

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            colorTextHeading: palette.primary[9],
            colorText: palette.primary[9],
          },
        },
        token: {},
      }}
    >
      {children}
    </ConfigProvider>
  );
}

function Title({ children }: { children: ReactNode }) {
  const palette = usePalette();

  return (
    <Text
      className={twMerge("rounded-t-lg", paddings)}
      style={{
        backgroundColor: palette.neutral[2],
      }}
      weight={"500"}
    >
      {children}
    </Text>
  );
}
